<a
  href="#"
  (click)="copyMessage(LegacyTokenIdentifierStep2); false;"
  title="Copy identifier"
>Click to copy: Token Step contract</a>: {{LegacyTokenIdentifierStep2}}
<hr />
<a [routerLink]="['/registration',projectShortName,'step2',LegacyTokenIdentifierStep2]" target="_blank">Step2</a>
